import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth, homePath } from "@/lib/auth.jsx";
import Logo from "@/components/Logo";

/**
 * AuthCallback handles the Emergent Auth redirect.
 * Reads session_id from the URL fragment, exchanges it via our backend,
 * stores the JWT, then routes to the role-appropriate landing page.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sessionId = params.get("session_id");
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        setToken(data.access_token);
        setUser(data.user);
        // Clean the fragment from URL before navigation
        window.history.replaceState({}, "", window.location.pathname);
        navigate(homePath(data.user), { replace: true });
      } catch {
        navigate("/login", { replace: true, state: { error: "Google sign-in failed. Please try again." } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg-app)] p-6">
      <Logo size={48} />
      <p className="mt-6 text-neutral-500 text-sm">Finishing sign-in...</p>
      <div className="mt-3 w-7 h-7 border-2 border-propera/30 border-t-propera rounded-full animate-spin" />
    </div>
  );
}
